import SignUpStepContainer from "./SignUpStepContainer";
import { CalendlyInlineEmbed } from "./CalendlyInlineEmbed";
import { FC, useEffect, useState } from "react";
import { ButtonIcon } from "../UI/Buttons";
import { REGISTRATION_STEPS } from "@/data";

const VisitRegistrationStep: FC<{
  onEventScheduled?: (data: any) => void;
  productSteps: REGISTRATION_STEPS[];
}> = ({ onEventScheduled, productSteps }) => (
  <SignUpStepContainer
    step={REGISTRATION_STEPS.CALENDLY_REG}
    productSteps={productSteps}
    header="Nuotolinė konsultacija"
    description={[
      "Jūsų sveikatos kelionė prasideda nuo patogaus pokalbio su mūsų specialistu.",
      `Konsultacija vyksta vaizdo skambučiu "Google Meet" platformoje ir trunka apie 30 minučių.`,
      "Tai puiki proga aptarti Jūsų klausimus ir gauti asmeninį sveikatingumo planą.",
    ]}
  >
    {/*{import.meta.env.VITE_IS_TEST && (*/}
    {/*  <Button onClick={onEventScheduled}>Fake submit (only on test)</Button>*/}
    {/*)}*/}
    <CalendlyVisitReservation onEventScheduled={onEventScheduled} />
  </SignUpStepContainer>
);

export default VisitRegistrationStep;

const CalendlyVisitReservation: FC<{
  onEventScheduled?: (data: any) => void;
}> = ({ onEventScheduled }) => {
  const [eventData, setEventData] = useState();

  useEffect(() => {
    if (!onEventScheduled) return;

    const handleMessage = (event: MessageEvent) => {
      // Only accept messages from Calendly+
      if (event.origin !== "https://calendly.com") return;

      // Check if it's the "EventScheduled" message
      if (event.data.event && event.data.event === "calendly.event_scheduled") {
        setEventData(event.data);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onEventScheduled]);

  const calendlyUrl = `${import.meta.env.VITE_CALENDLY_URL}?primary_color=2a1645`;

  return (
    <>
      <CalendlyInlineEmbed
        url={calendlyUrl}
        className="h-[500px] w-full min-w-full sm:h-[550px] md:h-[650px] md:min-w-[800px]"
      />
      {eventData && (
        <ButtonIcon
          className="mb-12 invert md:mb-16"
          icon="arrow-right"
          theme="light"
          label="Tęsti"
          onClick={onEventScheduled?.bind(null, eventData)}
        />
      )}
    </>
  );
};
